export var OperationalStatus;
(function (OperationalStatus) {
    OperationalStatus["FullyOperational"] = "Fully operational";
    OperationalStatus["Degraded"] = "Degraded";
    OperationalStatus["Offline"] = "Offline";
})(OperationalStatus || (OperationalStatus = {}));
